<script>
import 'chartjs-adapter-moment'
import { Bar } from 'vue-chartjs'
import ChartDataLabels from 'chartjs-plugin-datalabels'

export default {
  name: 'CBarChart',
  extends: Bar,
  props: {
    chartData: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      required: true
    }
  },
  watch: {
    chartData () {
      this.renderBarChart()
    }
  },
  mounted () {
    this.addPlugin(ChartDataLabels)
  },
  methods: {
    renderBarChart () {
      this.renderChart(this.chartData, this.options)
    }
  }
}
</script>
